<div id="mainWrapper" class="container">
    <section id="content-wrapper">
        <main style="padding-left: 64px">
            <div class="wrap">
                <div class="profit_and_loss_statement_page">
                    <h1 i18n="@@report.reports">Reports</h1>
                    <div class="main_body">
                        <div class="main_body-header">
                            <h4 i18n="@@report.profit_loss_statement">Profit & Loss Statement</h4>
                            <div
                                class="d-flex align-items-center gap-2 flex-grow-1 justify-content-end justify-none-start flex-wrap">
                                <!-- <div class="custom_select comparedSpanOff no-compare">

                                    <div class="custom_select-header"
                                        (click)="toggleDropdown($event)">
                                        <div>{{ selectedText }}</div>
                                        <div class="custom_select-icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24" viewBox="0 0 24 24"
                                                fill="none">
                                                <path d="M6 9L12 15L18 9"
                                                    stroke="#0A0A0A"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <ul class="custom_select-content"
                                        style="display: none;">

                                        <li *ngFor="let option of dateOptions"
                                            class="custom_select-item d-flex align-items-center justify-content-between"
                                            (click)="selectItem($event, option)">
                                            <span>{{ option.label }}</span>
                                            <span>{{ option.range }}</span>
                                        </li>
                                        <li
                                            class="custom_select-item d-flex align-items-center justify-content-between"
                                            (click)="selectItem($event, null); openDataPicker()">
                                            <span
                                                i18n="@@dashboard.custom_range">Custom
                                                range</span>
                                            <span>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none">
                                                    <path
                                                        d="M7.5 15L12.5 10L7.5 5"
                                                        stroke="#393939"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                        </li>
                                    </ul>
                                    <div id="custom_datepicker-popup"
                                        class="custom_datepicker-popup hidden">
                                        <div
                                            class="d-flex align-items-center gap-2 mb-3">
                                            <span
                                                i18n="@@dashboard.from">from</span>
                                            <input #startDayInput
                                                id="start_day_input" type="text"
                                                placeholder="Start date"
                                                readonly>
                                            <span
                                                i18n="@@dashboard.to">to</span><input
                                                #endDayInput id="end_day_input"
                                                type="text"
                                                placeholder="End date" readonly>
                                        </div>
                                        <div class="custom_datepicker-header">
                                            <span id="month-year">{{
                                                monthNames[currentDate.getMonth()]
                                                }} {{ currentDate.getFullYear()
                                                }}</span>
                                            <div
                                                class="d-flex align-items-center gap-2">
                                                <div
                                                    (click)="currentDate.setMonth(currentDate.getMonth() - 1); updateCalendar();">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="26"
                                                        height="26"
                                                        viewBox="0 0 26 26"
                                                        fill="none">
                                                        <path
                                                            d="M21.6988 15.6736L13.5725 7.54729C13.4184 7.39469 13.2103 7.30908 12.9935 7.30908C12.7766 7.30908 12.5685 7.39469 12.4145 7.54729L4.28814 15.6736C4.1779 15.7911 4.10318 15.9374 4.07262 16.0956C4.04206 16.2538 4.05691 16.4174 4.11546 16.5675C4.17763 16.7154 4.28218 16.8416 4.41595 16.9302C4.54972 17.0187 4.70671 17.0657 4.86714 17.0652H21.1198C21.2802 17.0657 21.4372 17.0187 21.571 16.9302C21.7048 16.8416 21.8093 16.7154 21.8715 16.5675C21.93 16.4174 21.9449 16.2538 21.9143 16.0956C21.8838 15.9374 21.809 15.7911 21.6988 15.6736Z"
                                                            fill="#222222" />
                                                    </svg>
                                                </div>
                                                <div
                                                    (click)="currentDate.setMonth(currentDate.getMonth() + 1); updateCalendar();">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="26"
                                                        height="26"
                                                        viewBox="0 0 26 26"
                                                        fill="none">
                                                        <path
                                                            d="M21.8759 9.43671C21.8137 9.28881 21.7092 9.16262 21.5754 9.07404C21.4416 8.98547 21.2846 8.93847 21.1242 8.93897H4.87154C4.7111 8.93847 4.55411 8.98547 4.42034 9.07404C4.28658 9.16262 4.18202 9.28881 4.11985 9.43671C4.06131 9.58681 4.04645 9.75042 4.07701 9.90861C4.10757 10.0668 4.1823 10.2131 4.29254 10.3306L12.4189 18.4569C12.5742 18.6071 12.7818 18.6911 12.9979 18.6911C13.2139 18.6911 13.4215 18.6071 13.5769 18.4569L21.7032 10.3306C21.8134 10.2131 21.8882 10.0668 21.9187 9.90861C21.9493 9.75042 21.9344 9.58681 21.8759 9.43671Z"
                                                            fill="#222222" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="custom_datepicker-days">
                                            <span>Su</span><span>Mo</span><span>Tu</span><span>We</span><span>Th</span><span>Fr</span><span>Sa</span>
                                        </div>
                                        <div class="custom_datepicker-grid"
                                            #datepickerGrid></div>
                                        <div class="custom_datepicker-footer">
                                            <button (click)="cancelDataPicker()"
                                                class="secondary_btn w-100"
                                                style="height: 40px;">Cancel</button>
                                            <button (click)="applyDateRange()"
                                                class="primary_btn w-100"
                                                style="height: 40px;">Apply</button>
                                        </div>
                                    </div>

                                </div> -->
                                <div
                                    class="secondary_btn comparedSpanOff no-compare"
                                    (click)="openPopup()">
                                    <ng-container i18n="@@report.compare_period">Compare periods</ng-container>
                                </div>
                                <div class="secondary_btn comparedSpan deleteCompare"
                                    class="secondary_btn comparedSpan deleteCompare"
                                    (click)="hideCompare()">
                                    <ng-container i18n="@@report.back_to_deafault">Back to default view</ng-container>
                                </div>
                                <div class="custom_select downloader">
                                    <div class="custom_select-header" (click)="toggleDropdown($event)">
                                        <div i18n="@@report.download_as">Download as</div>
                                        <div class="custom_select-icon">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path d="M6 9L12 15L18 9"
                                                    stroke="#ffffff"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="custom_select-content">
                                        <div (click)="downloadPDF()"
                                            class="custom_select-item downloadAsPDF">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="17"
                                                viewBox="0 0 16 17" fill="none">
                                                <path
                                                    d="M6 7.83333V11.8333L7.33333 10.5"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M6.00002 11.8333L4.66669 10.5"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M14.6666 7.16666V10.5C14.6666 13.8333 13.3333 15.1667 9.99998 15.1667H5.99998C2.66665 15.1667 1.33331 13.8333 1.33331 10.5V6.5C1.33331 3.16666 2.66665 1.83333 5.99998 1.83333H9.33331"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M14.6667 7.16666H12C10 7.16666 9.33337 6.49999 9.33337 4.49999V1.83333L14.6667 7.16666Z"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <ng-container i18n="@@report.pdf">PDF</ng-container>
                                        </div>
                                        <div (click)="downloadExcel()"
                                            class="custom_select-item downloadAsXLSX">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16" height="17"
                                                viewBox="0 0 16 17" fill="none">
                                                <path
                                                    d="M6 7.83333V11.8333L7.33333 10.5"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M6.00002 11.8333L4.66669 10.5"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M14.6666 7.16666V10.5C14.6666 13.8333 13.3333 15.1667 9.99998 15.1667H5.99998C2.66665 15.1667 1.33331 13.8333 1.33331 10.5V6.5C1.33331 3.16666 2.66665 1.83333 5.99998 1.83333H9.33331"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M14.6667 7.16666H12C10 7.16666 9.33337 6.49999 9.33337 4.49999V1.83333L14.6667 7.16666Z"
                                                    stroke="#646464"
                                                    stroke-width="1.5"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <ng-container i18n="@@report.xlsx">XLSX</ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sub-heading" i18n="@@report.statement_of_operations_data">
                            Consolidated Statements of Operations Data
                        </div>
                        <div class="compare_period_head comparedSpan">
                            <span i18n="@@report.compare_period">Compare periods</span>
                            <div
                                class="d-flex align-items-center gap-2 flex-grow-1 justify-content-end justify-none-start">
                                <div class="custom_select">
                                    <div class="custom_select-header"
                                        (click)="togglePeriodDropdown($event, 'period1')">
                                        <div class="sub-title">{{ selectedTextPeriod1 }}</div>
                                        <div class="custom_select-icon">
                                            <svg width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path d="M6 9L12 15L18 9"
                                                    stroke="#0A0A0A"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <ul class="custom_select-content">
                                        <li class="custom_select-item"
                                            *ngFor="let option of dateOptions"
                                            (click)="selectPeriods($event, option, 'period1')">
                                            <span>{{ option.label }}</span>
                                            <span>{{ option.range }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="custom_select">
                                    <div class="custom_select-header"
                                        (click)="togglePeriodDropdown($event, '2')">
                                        <div class="sub-title">{{ selectedTextPeriod2 }}</div>
                                        <div class="custom_select-icon">
                                            <svg width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path d="M6 9L12 15L18 9"
                                                    stroke="#0A0A0A"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                    <ul class="custom_select-content">
                                        <li class="custom_select-item"
                                            *ngFor="let option of dateOptions"
                                            (click)="selectPeriods($event, option, 'period2')">
                                            <span>{{ option.label }}</span>
                                            <span>{{ option.range }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="main_body-body">
                            <div *ngFor="let category of financialData" class="category-block">
                                <div class="title">
                                    {{ category.label }}
                                    <ng-container *ngIf="category === financialData[0]">
                                    <div class="w-50" [ngClass]="periods.length > 1 ? 'd-flex justify-content-between' : 'text-end'">
                                        <div *ngFor="let period of periods" class="desktop-only sub-title language-cell">
                                            {{ period }}
                                        </div>
                                    </div>
                                    </ng-container>
                                </div>
                                <div *ngFor="let item of category.items" class="row">
                                    <div class="cell">{{ item.name }}</div>
                                    <div *ngFor="let value of item.periods | keyvalue" class="cell language-cell">
                                        {{ value.value | number }} SAR
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </section>
    <!-- end content-wrapper -->

    <!-- Popup -->
    <div class="base_bg_modal" *ngIf="isPopupOpen">

        <div class="data_range_popup">
            <h4>
                <ng-container i18n="@@report.select_date_range">Select date ranges</ng-container>
                <svg
                    class="closeModal"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    (click)="closePopup()">
                    <path
                        d="M24 8L8 24M8 8L24 24"
                        stroke="#646464"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </h4>
            <div class="d-flex align-items-center gap-4 w-100">
                <div class="d-flex flex-column w-50 gap-2 w-none-100">
                    <span class="custom_label" i18n="@@report.period1">Period 1</span>
                    <div class="custom_select comparedSpanOff">
                        <div class="custom_select-header"
                            (click)="togglePeriodDropdown($event, 'period1')">
                            <div>{{ selectedTextPeriod1 }}</div>
                            <div class="custom_select-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                                        stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <ul class="custom_select-content">
                            <li class="custom_select-item"
                                *ngFor="let option of dateOptions"
                                (click)="selectPeriods($event, option, 'period1')">
                                <span>{{ option.label }}</span>
                                <span>{{ option.range }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="d-flex flex-column w-50 gap-2 w-none-100">
                    <span class="custom_label" i18n="@@report.period2">Period 2</span>
                    <div class="custom_select comparedSpanOff">
                        <div class="custom_select-header"
                            (click)="togglePeriodDropdown($event, 'period2')">
                            <div>{{ selectedTextPeriod2 }}</div>
                            <div class="custom_select-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path d="M6 9L12 15L18 9" stroke="#0A0A0A"
                                        stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <ul class="custom_select-content">
                            <li class="custom_select-item"
                                *ngFor="let option of dateOptions"
                                (click)="selectPeriods($event, option, 'period2')">
                                <span>{{ option.label }}</span>
                                <span>{{ option.range }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="d-flex w-100 justify-content-end">
                <div class="primary_btn setCompare"
                    (click)="compare()" i18n="@@report.compare">Compare</div>
            </div>
        </div>
    </div>

</div>